module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAANCAYAAACZ3F9/AAAAAXNSR0IArs4c6QAAAUtJREFUKFON0jEorXEYx/Hv7z0GyXgmiehOFsNd1XmPbOoOlLKeIxMWE8mgWGQxGc57BnXrDncwKBnwqpuFZFGUhdQtRwYLBu9PrxDh5dn+Pf/P0/P8n78ACpFHhceBxvScEVdIk3FJf5VeCqPkAHEjtJalErtfUIvLQc8zPAL/i8u5oSwYVpIVRD4uB13vYBglq0DT6wI2/7eHgt5MWIjuZwNoewPhNC7nJt7AsOIRlD6MN77VKrQiVRRGSQ3IG/YDaXKrpPWP5ixG7k/wjKADuEzhpeFU0GBoB/YC63fhnKXDDuourhmX3Ad0AkfAHdD2CCUt+ow5t5DucwDzEzgG6oFmzC6BlsMzqtstTNkee4FbJc08t1iM/Mt42OIuhxY2S9p5yVU9/SnM2mXxFTwHTiRtfvHdHtO2u4EfCqv381iDT/N8x96C/zwANhykXNuhN4QAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/menus_icon/tkgl_active.png
// module id = kGgh
// module chunks = 3